import { render, staticRenderFns } from "./instagramPostTemplate.vue?vue&type=template&id=ca423c34&scoped=true&"
import script from "./instagramPostTemplate.vue?vue&type=script&lang=js&"
export * from "./instagramPostTemplate.vue?vue&type=script&lang=js&"
import style0 from "./instagramPostTemplate.vue?vue&type=style&index=0&id=ca423c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca423c34",
  null
  
)

component.options.__file = "instagramPostTemplate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VProgressCircular,
})
